// src/auth/protected-route.js

import { Route, Redirect } from "react-router-dom";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { Loading } from "../components/index";
import { hasRoles } from '../common/auth0Common';

const RoleProtectedComponent = ({ component: Component, allowedRoles = [] }) => {
  const { user, isLoading } = useAuth0();
  if (isLoading || !user) {
    return <Loading />;
  }

  //Check if any of the allowed roles exists
  const hasAccess = hasRoles(user, allowedRoles);
  if (!hasAccess) {
    return <Redirect to="/unauthorized" />;
  }
  return <Component />;
};

const ProtectedRoute = ({ component, allowedRoles = [], ...args }) => {
  const AuthenticationComponent = withAuthenticationRequired(
    () => <RoleProtectedComponent component={component} allowedRoles={allowedRoles} />,
    {
      onRedirecting: () => <Loading />,
    }
  );

  return <Route component={AuthenticationComponent} {...args} />;
};

export default ProtectedRoute;
